import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { InfoPagesStyleProps } from '../../types';

const columnMinWidth = '180px';

export const InfoPagesList = styled.ul`
  list-style: none;
  margin: 0;
`;

export const ListItem = styled.li`
  margin-bottom: ${layout.spacing.xSmall};
`;

export const Link = styled.a`
  color: ${p => p.theme.footer.fg.primary};

  &:hover {
    color: ${p => p.theme.buttons.link.textHover};
  }
`;

export const Column = styled.div<InfoPagesStyleProps>`
  margin: 0 ${layout.spacing.xSmall} ${layout.spacing.small};

  display: flex;
  flex-direction: column;
  flex-shrink: 1;

  ${media.mediumUp`
    min-width: ${columnMinWidth};
  `};

  ${media.smallOnly`
    margin: 0;
    margin-bottom: ${layout.spacing.small};

    ${(p: InfoPagesStyleProps) =>
      p.numberOfColumns &&
      css`
        /* Adds margin to all columns except the first in every row */
        &:not(:nth-child(${p.numberOfColumns}n+1)) {
          margin-left: ${layout.spacing.small};
        }
      `}

    
  `};
`;
